
































import { defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { capitalizeAllWords } from '~/utils/string'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { name } = toRefs(props)

    const customKeyValues = ref<{ name: string; value: string }[]>([
      { name: '', value: '' }
    ])

    const { debouncedValueChanged, error } = useClassifiedForm(props, {
      onValue: v => {
        if (v.value?.length) {
          customKeyValues.value = v.value

          const lastKeyValueEntry =
            customKeyValues.value[customKeyValues.value.length - 1]
          if (lastKeyValueEntry.name || lastKeyValueEntry.value) {
            addKeyValueEntry()
          }
        }
      }
    })

    function handleNameInput() {
      if (lastEntryHasNameAndValue()) {
        addKeyValueEntry()
      }
      debouncedValueChanged(name.value, customKeyValues.value)
    }

    function handleValueInput() {
      if (lastEntryHasNameAndValue()) {
        addKeyValueEntry()
      }
      debouncedValueChanged(name.value, customKeyValues.value)
    }

    function lastEntryHasNameAndValue() {
      const lastKeyValueEntry =
        customKeyValues.value[customKeyValues.value.length - 1]

      return Boolean(
        lastKeyValueEntry.name.length && lastKeyValueEntry.value.length
      )
    }

    function addKeyValueEntry() {
      customKeyValues.value.push({ name: '', value: '' })
    }

    function showHelperText(index: number) {
      return index === customKeyValues.value.length - 1
    }

    return {
      error,
      showHelperText,
      customKeyValues,
      handleNameInput,
      handleValueInput,
      capitalizeAllWords
    }
  }
})
